<app-breadcrumb
  *ngIf="!commissionUpdatePackageObject"
  [master]="'Rozliczenia'"
  [parentName]="'Konfigurator'"
  [name]="'Dodaj'"
></app-breadcrumb>

<div class="commission-update-package-add" fxLayout="column" fxLayoutGap="15px" [formGroup]="commissionUpdatePackageForm">

  <!-- ACTION BUTTONS -->
  <div fxLayout="row" fxLayoutGap="15px">
    <button
      (click)="save()"
      [class.spinner]="processingRequest"
      [disabled]="isSaveDisabled"
      mat-stroked-button
      color="primary"
    >
      <mat-icon>save</mat-icon>
      <span>Zapisz</span>
    </button>

    <button
      *ngIf="!commissionUpdatePackageObject"
      (click)="save(true)"
      [class.spinner]="processingRequest"
      [disabled]="isSaveDisabled"
      mat-stroked-button
      color="primary"
    >
      <mat-icon>save</mat-icon>
      <span>Zapisz i dodaj kolejny</span>
    </button>

    <button (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span>Anuluj</span>
    </button>
  </div>

  <!-- FORM CONTENT -->
  <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-lg="column">
    <div fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>

        <!-- Insurance Company -->
        <div fxLayout="row">
          <app-dict-insurance-companies
            fxFlex="100"
            label="TU"
            [required]="true"
            [control]="insuranceCompanyControl"
            (selectedInsuranceCompany)="insuranceCompanyChanged($event)"
            [hideChildren]="true"
            [onlyKeys]="insuranceCompanyKeys"
          ></app-dict-insurance-companies>
        </div>

        <!-- Importer -->
        <div fxLayout="row">
          <app-dict
            fxFlex="100"
            [required]="true"
            [control]="importerControl"
            [dictType]="'commission_importer_' + selectedInsuranceCompany?.key"
            matTooltip="Najpierw wybierz TU"
            matTooltipPosition="left"
            [matTooltipDisabled]="!!selectedInsuranceCompany"
            label="Importer"
          ></app-dict>
        </div>

        <!-- Company -->
        <div fxLayout="row">
          <app-dict
            fxFlex="100"
            dictType="company"
            label="Firma"
            [required]="true"
            [control]="companyControl"
          ></app-dict>
        </div>

        <!-- Partner -->
        <div fxLayout="row">
          <app-dict-partners
            fxFlex="100" label="Partner"
            [control]="partnerControl" [required]="false"
          ></app-dict-partners>
        </div>

        <!-- OFWCA -->
        <div fxLayout="row">
          <app-dict-ofwcas
            fxFlex="100"
            label="OFWCA"
            [control]="ofwcaControl" [required]="false">
          </app-dict-ofwcas>
        </div>


        <!-- Risk Code & Pack -->
        <div fxLayout="row" fxLayoutGap="15px">
          <mat-form-field fxFlex="50">
            <mat-label>Kod ryzyka</mat-label>
            <input matInput placeholder="Kod ryzyk" [formControl]="riskCodeControl" />
          </mat-form-field>

          <mat-form-field fxFlex="50">
            <mat-label>Kod grupy</mat-label>
            <input matInput placeholder="Kod grupy" [formControl]="riskPackControl" />
          </mat-form-field>
        </div>

        <!-- Risks Form Array -->
        <ng-container formArrayName="risks">
          <div *ngFor="let group of risksFormArray.controls; let i = index" [formGroupName]="i">
            <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" >
              <div fxFlex="5" class="list-counter">
                {{ i + 1 }}.
              </div>

              <div fxFlex="90" fxLayoutGap="15px">
              <app-dict
                fxFlex="30"
                dictType="internal_risk"
                [required]="true"
                label="Ryzyko"
                formControlName="internalRisk"
              ></app-dict>

              <mat-form-field fxFlex="30">
                <mat-label>Stawka % TU</mat-label>
                <input matInput placeholder="Stawka % TU" formControlName="importRate" />
              </mat-form-field>

              <mat-form-field fxFlex="30">
                <mat-label>Stawka % Partner</mat-label>
                <input matInput placeholder="Stawka % Partner" formControlName="ratePaid" />
              </mat-form-field>
              </div>
              <div fxFlex="5" fxLayoutAlign="center">
                <button (click)="removeRisks(i)" mat-icon-button color="warn">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Add Risk Button -->
        <div fxLayout="row" fxLayoutAlign="end">
          <button mat-stroked-button color="accent" (click)="addRisk()">
            <mat-icon>add</mat-icon>
            Dodaj ryzyko
          </button>
        </div>

        <!-- Toggles -->
        <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start center" style="padding: 10px 0;">
          <mat-slide-toggle fxFlex="50" color="accent" [formControl]="isPackageControl">Pakiet</mat-slide-toggle>
          <mat-slide-toggle fxFlex="50" color="accent" [formControl]="activeControl">Aktywny</mat-slide-toggle>
        </div>

      </mat-card>
    </div>
  </div>
</div>
